export enum TicketSpecialOffer {
  TwoPlusOne = 'TwoPlusOne',
  CoupleTicket = 'CoupleTicket',
}
